import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { LOCK_WSPOS } from './actionTypes';
import { lockWSPositionSuccessful, lockWSPositionFailed } from './actions';

// Include call API
import { getWorkstationsAPI } from "../../../api/workstations";

const wsposAPI = getWorkstationsAPI();

// Is user register successfull then direct plot user in redux.
function* lockWSPosition({ payload: { wspos, token , history } }) {
    try {
        console.log(wspos,token)
        const response = yield call(wsposAPI.lockWSPosition, wspos, token);
        history.go()
        yield put(lockWSPositionSuccessful(response.message));

    } catch (error) {
        console.log(error)
        yield put(lockWSPositionFailed(error));
    }
}

export function* watchUnlockWSPosition() {
    yield takeEvery(LOCK_WSPOS, lockWSPosition);
}

function* lockWSPositionSaga() {
    yield all([fork(watchUnlockWSPosition)]);
}

export default lockWSPositionSaga;